
    import {initializeApp} from 'https://www.gstatic.com/firebasejs/9.19.1/firebase-app.js'

    // If you enabled Analytics in your project, add the Firebase SDK for Google Analytics
    import {getAnalytics} from 'https://www.gstatic.com/firebasejs/9.19.1/firebase-analytics.js'

    // Add Firebase products that you want to use
  /*  import {getAuth} from 'https://www.gstatic.com/firebasejs/9.19.1/firebase-auth.js'*/
import { getFirestore } from 'https://www.gstatic.com/firebasejs/9.19.1/firebase-firestore.js'


import {
    getAuth,
    createUserWithEmailAndPassword,
    sendEmailVerification,
    updateProfile,
    signInWithEmailAndPassword,
    onAuthStateChanged,
    signOut,
    signInWithPopup,
    GoogleAuthProvider,
    FacebookAuthProvider,
    TwitterAuthProvider,
} from "https://www.gstatic.com/firebasejs/9.19.1/firebase-auth.js";
    

const firebaseConfig = {
    apiKey: "AIzaSyB799B7DS6fITQtflefME9u4baknreMTTQ",
    authDomain: "tellmyroute-2689e.firebaseapp.com",
    projectId: "tellmyroute-2689e",
    storageBucket: "tellmyroute-2689e.appspot.com",
    messagingSenderId: "735276613863",
    appId: "1:735276613863:web:2008633ba3d1a4f1546242",
    measurementId: "G-B7BB9LHBB6"
};
    // Initialize Firebase
const app = initializeApp(firebaseConfig);
const provider = new GoogleAuthProvider();
const auth = getAuth();
const analytics = getAnalytics(app);
function signin() {
signInWithPopup(auth, provider)
    .then((result) => {
        // This gives you a Google Access Token. You can use it to access the Google API.
        const credential = GoogleAuthProvider.credentialFromResult(result);
        const token = credential.accessToken;
        // The signed-in user info.
        const user = result.user;
        // IdP data available using getAdditionalUserInfo(result)
        // ...
        callLogin(user);
    }).catch((error) => {
        // Handle Errors here.
        const errorCode = error.code;
        const errorMessage = error.message;
        // The email of the user's account used.
        const email = error.customData.email;
        // The AuthCredential type that was used.
        const credential = GoogleAuthProvider.credentialFromError(error);
        // ...
    });
}
function callLogin(user) {
    console.log(user)
    $.ajax({
        url: "/Login/GoogleLogin",
        dataType: "json",
        method: "post",
        traditional: true,
        data:
        {
            user: JSON.stringify(user)
        }
    }).done(function (response) {
        window.location.href = response.data;
    });
}
document.getElementById("glink").onclick = function () {
    signin();
};

document.getElementById("glinkreg").onclick = function () {
    signin();
};


//Facebook SignIn
const fbprovider = new FacebookAuthProvider();
fbprovider.addScope("public_profile, email");
document
    .getElementById("fblink")
    .addEventListener("click", function () {
        signInWithPopup(auth, fbprovider)
            .then((result) => {
                // The signed-in user info.
                const user = result.user;
                // This gives you a Facebook Access Token. You can use it to access the Facebook API.
                const credential =
                    FacebookAuthProvider.credentialFromResult(result);
                const accessToken = credential.accessToken;
                callLogin(user);
                // IdP data available using getAdditionalUserInfo(result)
                // ...
            })
            .catch((error) => {
                // Handle Errors here.
                const errorCode = error.code;
                const errorMessage = error.message;
                // The email of the user's account used.
                const email = error.customData.email;
                // The AuthCredential type that was used.
                const credential = FacebookAuthProvider.credentialFromError(error);
                // ...
                console.log(errorCode, errorMessage, email, credential);
            });
    });

//Twitter SignIn
const twprovider = new TwitterAuthProvider();
document
    .getElementById("twittersignin")
    .addEventListener("click", function () {
        signInWithPopup(auth, twprovider)
            .then((result) => {
                // This gives you a the Twitter OAuth 1.0 Access Token and Secret.
                // You can use these server side with your app's credentials to access the Twitter API.
                const credential = TwitterAuthProvider.credentialFromResult(result);
                const token = credential.accessToken;
                const secret = credential.secret;

                // The signed-in user info.
                const user = result.user;
                window.location.href = "home.html";
                // IdP data available using getAdditionalUserInfo(result)
                // ...
            })
            .catch((error) => {
                // Handle Errors here.
                const errorCode = error.code;
                const errorMessage = error.message;
                // The email of the user's account used.
                const email = error.customData.email;
                // The AuthCredential type that was used.
                const credential = TwitterAuthProvider.credentialFromError(error);
                // ...
                console.log(errorCode, errorMessage, email, credential);
            });
    });